module.exports = __webpack_public_path__ + "img/portrait-056.7456504e.jpg";